import script from "./PerformanceOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./PerformanceOverview.vue?vue&type=script&setup=true&lang=js"

import "./PerformanceOverview.vue?vue&type=style&index=0&id=490375aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-490375aa"]])

export default __exports__